/**
 * 全局错误处理器
 * 捕获 Vue 错误、未处理的 Promise 拒绝和全局错误
 */

/**
 * 初始化全局错误处理
 */
export function initErrorHandler(Vue) {
  if (initErrorHandler.installed) return
  initErrorHandler.installed = true

  // 1. Vue 错误处理
  Vue.config.errorHandler = (err, vm, info) => {
    handleError(err, {
      type: 'vue',
      component: vm?.$options?.name || 'Anonymous',
      info,
      route: vm?.$route
    })
  }

  // 2. 未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', event => {
    handleError(event.reason, {
      type: 'unhandledrejection',
      promise: event.promise
    })
    // 防止控制台默认错误输出
    event.preventDefault()
  })

  // 3. 全局错误
  window.addEventListener('error', event => {
    handleError(event.error || new Error(event.message), {
      type: 'global',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    })
    // 防止控制台默认错误输出
    event.preventDefault()
  })

  // 4. 控制台错误劫持（可选）
  if (process.env.NODE_ENV === 'development') {
    interceptConsoleErrors()
  }
}

/**
 * 处理错误
 */
function handleError(error, context = {}) {
  // 忽略重复的导航错误
  if (error?.name === 'NavigationDuplicated') {
    return
  }

  console.error('[捕获错误]', error, context)

  // 在开发环境下显示错误提示
  if (process.env.NODE_ENV === 'development') {
    console.error('[错误详情]', error, context)
  }

  // 可以在这里添加错误上报逻辑
  // reportErrorToServer(error, context)
}

/**
 * 拦截控制台错误（仅开发环境）
 */
function interceptConsoleErrors() {
  const originalConsoleError = console.error
  console.error = function(...args) {
    // 调用原始方法
    originalConsoleError.apply(console, args)
  }

  const originalConsoleWarn = console.warn
  console.warn = function(...args) {
    originalConsoleWarn.apply(console, args)
  }
}

/**
 * 上报错误到服务器
 */
export function reportErrorToServer(error, context = {}) {
  const data = {
    message: error.message || String(error),
    stack: error.stack,
    type: error.name,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    userAgent: navigator.userAgent,
    ...context
  }

  // 使用 navigator.sendBeacon 或 fetch 上报
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/errors', JSON.stringify(data))
    } else {
      fetch('/api/errors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true
      })
    }
  } catch (e) {
    console.error('错误上报失败:', e)
  }
}